<template>
  <div class="password-wrapper">
    <input
      :class="modifier"
      :type='inputType'
      :id='id'
      :name="name"
      :required="required"
      :minlength="minlength"
      :autofocus="autofocus"
      v-model="internalValue"
      @focus="onFocus"
      :disabled='disabled ? "disabled" : null'
    />
    <a href="javascript:void(0)" class="toggle-password" @click="showPassword" aria-label="show the password">
      {{ toggleText }}
    </a>
  </div>
</template>

<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'

  export default {
    mixins: [ ValueInputBindings ],
    props: {
      autofocus: String,
      minlength: String,
      required: Boolean,
      value: String,
      name: String,
      id: String,
      disabled: Boolean,
      onFocus: {
        type: Function,
        default() {
        }
      },
      modifier: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        inputType: 'password',
        toggleText: 'show'
      }
    },
    methods: {
      showPassword () {
        if (this.inputType === 'password') {
          this.inputType = 'text'
          this.toggleText = 'hide'
        } else {
          this.inputType = 'password'
          this.toggleText = 'show'
        }
      }
    }
  }
</script>
